function Hero() {
  return (
    <section id="home" className="relative flex min-h-[92vh] items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=cheerful%20cartoon%20girl%20character%20laughing%20happily%20in%20the%20center%20surrounded%20by%20floating%20colorful%20comic%20speech%20bubbles%20and%20laugh%20symbols%2C%20vibrant%20warm%20orange%20and%20cream%20color%20palette%2C%20playful%20manga%20illustration%20style%2C%20soft%20warm%20lighting%2C%20expressive%20bold%20comic%20lines%2C%20lively%20and%20happy%20atmosphere&width=1600&height=900&seq=hero-manga-main&orientation=landscape"
          alt="大黄丫头漫画搞笑日常主角插画"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background-950/85 via-background-950/60 to-background-950/30"></div>
        <div className="absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-background-50 to-transparent"></div>
      </div>

      <div className="container-page relative z-10 w-full py-24">
        <div className="max-w-2xl">
          <span className="mb-6 inline-flex items-center gap-2 rounded-full bg-primary-500/90 px-4 py-1.5 text-sm font-bold text-background-50">
            <i className="ri-emotion-happy-line"></i>
            笑点合集 · 一话不落
          </span>

          <h1 className="font-heading text-4xl leading-tight text-background-50 md:text-6xl">
            大黄丫头漫画
            <span className="mt-3 block text-2xl text-secondary-200 md:text-3xl">
              搞笑日常 · 轻松解压 · 幽默片段合集
            </span>
          </h1>

          <p className="mt-6 max-w-xl text-base leading-relaxed text-background-100/90 md:text-lg">
            想找大黄丫头漫画笑点合集、看轻松解压内容？这里收录了丫头的搞笑日常与幽默片段，轻松向剧情一话不落。忙碌一天，让丫头带你哈哈大笑，把烦恼统统赶跑。
          </p>

          <div className="mt-8 flex flex-col gap-4 sm:flex-row sm:items-center">
            <a
              href="#featured"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById("featured")?.scrollIntoView({ behavior: "smooth" });
              }}
              className="btn-primary !bg-primary-500 !text-background-50 hover:!bg-primary-400"
            >
              看热门笑点
              <i className="ri-arrow-right-line ml-2"></i>
            </a>
            <a
              href="#collections"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById("collections")?.scrollIntoView({ behavior: "smooth" });
              }}
              className="inline-flex items-center justify-center whitespace-nowrap rounded-full border-2 border-background-100/70 px-6 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-background-100/20"
            >
              逛片段合集
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;